module.exports = __webpack_public_path__ + "img/trunk_5x1_z16.5e627808.svg";